module.exports = __webpack_public_path__ + "img/3.3c5725cb.png";